//共通で24は使わない


export const DiseaseAll = '';
//その他
export const DiseaseOthers = '1,2,3,7,8,9,10,23,25';
//感染症
export const DiseaseInfections = '4';
//性別
export const DiseaseGender = '5,6';
//循環器
export const DiseaseCirculatory = '11';
//呼吸器
export const DiseaseRespiratory = '12';
//消化器
export const DiseaseDigestive = '13';
//神経系
export const DiseaseNeurological = '14';
//内分泌
export const DiseaseEndocrineGlands = '15';
//泌尿器
export const DiseaseUrinary = '16';
//骨・関節・皮膚
export const DiseaseOsteoSkin = '17,18';
//血液・免疫
export const DiseasebloodImmunity = '19';
//目・耳・鼻・口
export const DiseaseEyeEarNoseOral = '20,21,22';

export const ConstitutionAll = '';
//栄養素
export const ConstitutionNutrients = '1';
//志向性/行動
export const ConstitutionIntentionalityBehavior = '2';
//能力
export const ConstitutionAbility = '3';
//その他
export const ConstitutionOthers = '4,8,9,10,11,12,13,14,15,16,25';
//性別
export const ConstitutionGender = '5,6';
//体型・体格
export const ConstitutionBodyStructure = '7,23';
//骨・関節・皮膚
export const ConstitutionOsteoSkin = '17,18';
//血液・免疫
export const ConstitutionBloodImmunity = '19';
//目・耳・鼻・口
export const ConstitutionEyeEarNoseOral = '20,21,22';



// WEBPACK FOOTER //
// ./src/constants/Categories.js